module.exports = __webpack_public_path__ + "img/blr.f4cbd761.svg";